import { withTranslations } from 'hooks/useTranslations'
import Component from './CartPriceTable'
import { graphql, useStaticQuery } from 'gatsby'
declare global {
  interface Snippets {
    'molecules-account-CartPriceTable': {
      cartpricetable_cart: void
      cartpricetable_subtotal: void
      cartpricetable_deliverycost: void
      cartpricetable_deliveryvoucher: void
      cartpricetable_plus_vat: {
        vatPercentage: string
      }
      cartpricetable_eco_tax: void
      cartpricetable_total: {
        VATINFO: string
      }
      deliverymodal_shipping_cost: void
      deliverymodal_shipping_description_text: void
      deliverymodal_bulky_goods: void
      deliverymodal_bulky_goods_description: void
      deliverymodal_bulky_goods_description_cost_down_1000_text: void
      deliverymodal_bulky_goods_description_cost_down_1000: { BULKYGOODS: any }
      deliverymodal_bulky_goods_description_cost_down_2000_text: void
      deliverymodal_bulky_goods_description_cost_down_2000: { BULKYGOODS: any }
      deliverymodal_bulky_goods_description_cost_up_2000_text: void
      deliverymodal_bulky_goods_description_cost_up_2000: { BULKYGOODS: any }
    }
  }
}
/* required to add Translation in Contentful
cartpricetable_tax_eco: snippet(
      group: "molecules-account-CartPriceTable"
      name: "cartpricetable_tax_eco"
)*/
export default withTranslations(Component, () =>
  useStaticQuery(graphql`
    query molecules_account_CartPriceTable_translations {
      cartpricetable_cart: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_cart"
      )
      cartpricetable_subtotal: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_subtotal"
      )
      cartpricetable_eco_tax: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_eco_tax"
      )
      cartpricetable_deliverycost: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_deliverycost"
      )
      cartpricetable_deliveryvoucher: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_deliveryvoucher"
      )
      cartpricetable_plus_vat: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_plus_vat"
      )
      cartpricetable_total: snippet(
        group: "molecules-account-CartPriceTable"
        name: "cartpricetable_total"
      )
      deliverymodal_shipping_cost: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_shipping_cost"
      )
      deliverymodal_shipping_description_text: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_shipping_description_text"
      )
      deliverymodal_bulky_goods: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods"
      )
      deliverymodal_bulky_goods_description: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description"
      )
      deliverymodal_bulky_goods_description_cost_down_1000: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_down_1000"
      )
      deliverymodal_bulky_goods_description_cost_down_1000_text: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_down_1000_text"
      )
      deliverymodal_bulky_goods_description_cost_down_2000: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_down_2000"
      )
      deliverymodal_bulky_goods_description_cost_down_2000_text: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_down_2000_text"
      )
      deliverymodal_bulky_goods_description_cost_up_2000: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_up_2000"
      )
      deliverymodal_bulky_goods_description_cost_up_2000_text: snippet(
        group: "molecules-account-CartPriceTable"
        name: "deliverymodal_bulky_goods_description_cost_up_2000_text"
      )
    }
  `)
)
